import i18next from "i18next";
const t = i18next.t;
const questionType = "Question Types";
const formattingType = "Formating";
const other = "Other";

export const QUESTION_TYPE_LIST = [
  {
    quesType: questionType,
    main: t("surveyBuilder:addQuestionBank.addQuestionBankLabel"),
    id: "textSnippet",
    subText: t("surveyBuilder:addQuestionBank.addQuestionBankDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.shortLabel"),
    id: "textfield",
    subText: t("surveyBuilder:questionType.shortDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.longLabel"),
    id: "textarea",
    subText: t("surveyBuilder:questionType.longDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.singleLabel"),
    id: "radios",
    subText: t("surveyBuilder:questionType.singleDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.multiLabel"),
    id: "checkboxes",
    subText: t("surveyBuilder:questionType.multiDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.dropdownLabel"),
    id: "select",
    subText: t("surveyBuilder:questionType.dropdownDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.thumbsupLabel"),
    id: "webform_rating",
    subText: t("surveyBuilder:questionType.thumbsDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.facesLabel"),
    id: "faces",
    subText: t("surveyBuilder:questionType.facesDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.matrixLabel"),
    id: "matrix",
    subText: t("surveyBuilder:questionType.matrixDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.ratingLabel"),
    id: "range",
    subText: t("surveyBuilder:questionType.ratingDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.ratingNumericLabel"),
    id: "rangeNumeric",
    subText: t("surveyBuilder:questionType.ratingNumericDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.npsLabel"),
    id: "NPS",
    subText: t("surveyBuilder:questionType.npsDesc"),
    useImageIcon: true,
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.rankingLabel"),
    id: "ranking",
    subText: t("surveyBuilder:questionType.rankingDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.contentLabel"),
    id: "content",
    subText: t("surveyBuilder:questionType.contentDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.mediaUploadLabel"),
    id: "mediaUpload",
    subText: t("surveyBuilder:questionType.mediaUploadDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.contactFormLabel"),
    id: "contact_form",
    subText: t("surveyBuilder:questionType.contactFormDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.numberLabel"),
    id: "number",
    subText: t("surveyBuilder:questionType.numberDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.dateTimeLabel"),
    id: "datetime",
    subText: t("surveyBuilder:questionType.dateTimeDesc"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:questionType.imageSelectionLabel"),
    id: "image",
    subText: t("surveyBuilder:questionType.imageSelectionDesc"),
  },
  //Removing For GDVCVR-11741
  // {
  //   quesType: questionType,
  //   main: t("surveyBuilder:questionType.hiddenLabel"),
  //   id: "hidden",
  //   subText: t("surveyBuilder:questionType.hiddenDesc"),
  // },
];

export const FORMAT_TYPE_LIST = [
  //For future Use
  // {
  //   type: formattingType,
  //   main: t("surveyBuilder:formatting.break"),
  //   id: "textSnippet",
  //   subText: t("surveyBuilder:formatting.break"),
  // },
  {
    type: formattingType,
    main: t("surveyBuilder:formatting.passThroughLink"),
    id: "passThroughLink",
    subText: t("surveyBuilder:formatting.passThroughLink"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:formatting.hiddenVar"),
    id: "variable",
    variableType: "custom",
    subText: t("surveyBuilder:formatting.hiddenVar"),
  },
  {
    quesType: questionType,
    main: t("surveyBuilder:formatting.equationVar"),
    id: "equation",
    variableType: "equation",
    subText: t("surveyBuilder:formatting.equationVar"),
  },
];

export const OTHER_LIST = [
  {
    type: other,
    main: t("surveyBuilder:formatting.block"),
    id: "block",
    subText: t("surveyBuilder:formatting.block"),
  },
  {
    type: other,
    main: t("surveyBuilder:formatting.terminate"),
    id: "terminate",
    subText: t("surveyBuilder:formatting.terminate"),
  },
];

export const QUESTION_SEQUENCE = {
  id: "checkedB",
  main: t("surveyBuilder:questionSequence"),
};

export const PASS_THROUGH_LINK = t("surveyBuilder:PTLFormattingType");
